<mat-toolbar color="primary">
    <mat-toolbar-row class="menu-toolbar">
        <a fxShow="true" fxHide.gt-md href="https://www.restoreunited.com">
            <img [src]="srcLogo" class="logo item-toolbar" />
        </a>
        <div class="item-toolbar" fxShow="true" fxHide.lt-lg class="item-toolbar" style="width: 100%;">
            <div style="display: flex; width: 100%;">
                <a href="https://www.restoreunited.com">
                    <img [src]="srcLogo" class="logo item-toolbar" />
                </a>
                <span class="menu-spacer item-toolbar"></span>
                <!-- The following menu items will be hidden on both SM and XS screen sizes -->
                <ul class='nav menu'>
                    <li>
                        <a class='menu-link' href="https://www.restoreunited.com/">
                            Home
                        </a>
                    </li>
                    <li>
                        <a class='menu-link' href="https://www.restoreunited.com/why-restoreunited/">
                            Why RestoreUnited
                        </a>
                    </li>
                    <li>
                        <a class='menu-link' href="https://www.restoreunited.com/features/">
                            Features
                        </a>
                    </li>
                    <li>
                        <a class='menu-link' href="https://www.restoreunited.com/benchmarks/">
                            Benchmarks
                        </a>
                    </li>
                    <li>
                        <a class='menu-link' href="https://www.restoreunited.com/contact-us/">
                            Contact Us
                        </a>
                    </li>
                    <li>
                        <a class='menu-link' style="color: #ed1e24;" routerLink="/pricing">
                            Sign Up
                        </a>
                    </li>
                    <li class="phone-menu">
                        <a href="tel:8002001104">800-200-1104</a>
                    </li>
                </ul>
            </div>
        </div>
        <span class="example-spacer"></span>
        <div class="group-button" fxShow="true" fxHide.gt-md>
            <a href="tel:8002001104">
                <fa-icon [icon]="faPhoneSquareAlt" style="color:#BC4630;vertical-align: text-top; font-size: 30px;"></fa-icon>
            </a>

            <button mat-icon-button (click)="openNav()" [autofocus]="false" class="menu-btn">
                <mat-icon class="mat-icon">menu</mat-icon>
            </button>
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<div id="mySidenav" class="sidenav">
    <button class="closebtn" mat-icon-button (click)="closeNav()" [autofocus]="false">
        <mat-icon class="mat-icon">clear</mat-icon>
    </button>
    <div class="navbar-wrapper clearfix">
        <div class="social-widget">

        </div>
        <nav id="main-nav-wrap" itemscope="itemscope" itemtype="https://schema.org/SiteNavigationElement">
            <ul id="main-nav" class="main-nav menu-name-main-nav with-sub-arrow">
                <li>
                    <a class='menu-link' href="https://www.restoreunited.com/">
                        Home
                    </a>
                </li>
                <li>
                    <a class='menu-link' href="https://www.restoreunited.com/why-restoreunited/">
                        Why RestoreUnited
                    </a>
                </li>
                <li>
                    <a class='menu-link' href="https://www.restoreunited.com/features/">
                        Features
                    </a>
                </li>
                <li>
                    <a class='menu-link' href="https://www.restoreunited.com/benchmarks/">
                        Benchmarks
                    </a>
                </li>
                <li>
                    <a class='menu-link' href="https://www.restoreunited.com/contact-us/">
                        Contact Us
                    </a>
                </li>
                <li>
                    <a class='menu-link' routerLink="/pricing">
                        Sign Up
                    </a>
                </li>
                <li class="">
                    <a style="color: #bc4630;" href="tel:8002001104">800-200-1104</a>
                </li>
            </ul>
        <!-- /#main-nav -->
        </nav>
    <!-- /#main-nav-wrap -->
    </div>
</div>
<div class="margin-container-reponsive">
	<div class="loading" *ngIf="isLoading()">
		<mat-spinner color="warn"></mat-spinner>
	</div>
  <div class="title-body">
    <h4>We have a plan for your business!</h4>
  </div>
	<div class="row">
		<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-xs-12" *ngFor="let item of data">
			<div class="divMainContent">
        <div class="divUserProfile" style="text-align: center;position: relative;margin-top: 15px;">
          <p class="title-plan">{{item.Name_Plan}}</p>
          <div style="width: 312px; height: 312px; margin: 0 auto;" *ngIf="item.Name_Plan === 'Professional'">
            <img src="../../../assets/image/professional.png" [alt]="item.Label" style="padding-top: 64px; width: 217px; height: auto;">
          </div>
					<img *ngIf="item.Name_Plan !== 'Professional'" src="../../../assets/image/{{item.Name_Plan}}-plan.svg" [alt]="item.Label" width="312px" height="312px">
        </div>
        <div style="width: 100%; height: 84px;">

          <div *ngIf="item.Name_Plan == 'Advanced'" style="padding-top: 20px;">
              <div style="text-align: center; padding: 0px 20px;" id="advanced-price">We have the <span style="color: #BC4630;">solution</span> for everyone. Get in touch with us for a custom quote</div>
          </div>
        </div>
        <div style="padding-bottom: 20px; padding-left: 20px; padding-right: 20px;">
          <div class="padding10" style="display: flex; align-items: center; gap: 12px;">
			  <mat-icon color="errors" class="icon-done">done</mat-icon>
			  <span class="feature-plan" *ngIf="item.Name_Plan == 'Professional' || item.Name_Plan == 'Enterprise'">Up to {{ item.Number_User }} Users</span>
			  <span class="feature-plan" *ngIf="item.Name_Plan == 'Advanced'">Over {{ item.Number_User }} Users</span>
		  </div>
			<div class="padding10" *ngFor="let benefit of item.Benefit" style="display: flex; align-items: center; gap: 12px;">
				<mat-icon color="errors">done</mat-icon>
				<span class="feature-plan">{{ benefit }}</span>
			</div>
        </div>
        <div style="text-align: center; padding-bottom: 15px;">
          <button type="button"
                  class="btn btn-danger"
                  style="background: #BC4630;
                        border-radius: 10px;
                        width: 220px;"
                        (click)="navigateTo(item.Id, item.Name_Plan)"
                        >
                    {{ item.Name_Plan == 'Advanced' ? "Contact Us" : "Get Started"}}
          </button>
        </div>
			</div>
		</div>
    </div>

    <div class="divFooter">
        <span style="color: #BC4630;">
        Privacy Policy
    </span>
        <span class="clsBoder" style="color: #BC4630;">
        Terms & Conditions
    </span>
        <span style="color: #41404D;">
        Copyright 2020 RestoreUnited. All rights reserved.
    </span>
    </div>
</div>
